import { Vector } from '@iabtcf/core'

function userPreferenceModel (model) {
  const setIfConsented = (id) => (obj, [key, vector]) => {
    if (vector.has(id)) {
      obj[key] = true
    }
    return obj
  }
  const vectorToPrefArr = vector => {
    const pref = []
    vector.forEach((state, index) => {
      if (state) {
        pref.push(index)
      }
    })
    return pref
  }

  const consentedIds = obj => Array.from(new Set(Object.values(obj).map(vectorToPrefArr).flat()))

  // preferences keys: consents, legInterest, optIn
  const idsForUserPreference = preferences => {
    const ids = consentedIds(preferences)
    return ids.reduce((acc, id) => {
      acc[id] = Object.entries(preferences).reduce(setIfConsented(id), {})
      return acc
    }, {})
  }

  // key: vendors, purposes, specialFeatures
  return Object.entries(model).reduce((acc, [key, preferences]) => {
    acc[key] = idsForUserPreference(preferences)
    return acc
  }, {})
}

const userPreferenceVectors = ({ vendorConsents, vendorLegitimateInterests, purposeConsents, purposeLegitimateInterests, specialFeatureOptins }) => {
  return {
    vendors: {
      consent: vendorConsents,
      legInterest: vendorLegitimateInterests
    },
    purposes: {
      consent: purposeConsents,
      legInterest: purposeLegitimateInterests
    },
    specialFeatures: {
      optIn: specialFeatureOptins
    }
  }
}

function legitimateInterestPreferences (tcModel, hasUserSelectedTheirPreference) {
  const defaultLegitimateInterests = () => {
    const purposeLegitimateInterests = new Vector()
    purposeLegitimateInterests.setAll(tcModel.gvl.purposes)
    const vendorLegitimateInterests = new Vector()
    vendorLegitimateInterests.setAll(tcModel.gvl.vendors)
    return { vendorLegitimateInterests, purposeLegitimateInterests }
  }

  const userSelectedLegitimateInterests = () => ({
    purposeLegitimateInterests: tcModel.purposeLegitimateInterests,
    vendorLegitimateInterests: tcModel.vendorLegitimateInterests
  })

  return hasUserSelectedTheirPreference ? userSelectedLegitimateInterests() : defaultLegitimateInterests()
}

export default function (cmpModel) {
  const { vendorConsents, purposeConsents, specialFeatureOptins } = cmpModel.tcModel
  const { vendorLegitimateInterests, purposeLegitimateInterests } = legitimateInterestPreferences(cmpModel.tcModel, cmpModel.hasUserSelectedTheirPreference)
  const userPrefs = userPreferenceModel(userPreferenceVectors({
    vendorConsents,
    vendorLegitimateInterests,
    purposeConsents,
    purposeLegitimateInterests,
    specialFeatureOptins
  }))
  return userPrefs
}
